<template>
<div>
    <!-- 商家简介  -->
    <div class="detail" v-if="post.content">
        <h3 class="detail-header">商家简介</h3>
        <div class="editor-txt-content detail-content" v-html="ContentLinkAddRel(post.content)" ref="detailContent" :class="{'cutCont':isCut==1}" ></div>

        <!-- 详情图片预览 -->
        <YorkbbsImagePreview ref="imagePreview"></YorkbbsImagePreview>
       
    </div>
    <div class="unfold-more" v-if="isCut==1">
        <div class="zone" @click="isCut=3">展开查看更多</div>
    </div>
    <!-- 无简介 -->
    <div class="detail-empty" v-if="!post.content">
        <div class="detail-header">商家简介</div>
        <div class="detail-empty__tip">
        <i class="yk-empty"></i>
        <div>这个商家很懒，什么也没有发布</div>
        </div>
    </div>
</div>
</template>
<script>
import {ContentLinkAddRel} from '@/utils/utils';
import YorkbbsImagePreview from '@/common/image-preview.vue';

export default {
    name:'MerchantIntroduction',
    components:{YorkbbsImagePreview},
    props:{
        post:{
            type:Object,
            default:{
                property:{}
            }
        },
        
    },
    data(){
        return  {
            isCut:0,
            observer:null,
            count:0,
        }
    },
    methods:{
        ContentLinkAddRel(data){
            return ContentLinkAddRel(data);
        },
        checkSize(){
            this.count++;
            if( this.count >10){
                clearInterval(this.observer);
                return;
            }
            if( this.$refs.detailContent.scrollHeight>500){
                //走这里了
              
                if( this.isCut == 0 ){
                    this.isCut = 1;
                    clearInterval(this.observer);
                }
            }
        },   
    },
    updated(){
        this.observer = setInterval(()=>{
            this.checkSize();
        },500)
    },
}
</script>
<style lang="scss" scoped>

.detail {
  margin-bottom: 50px;
}
.detail-content {
  padding: 0;
    transition: all linear 150ms;
    &.cutCont{
        height: 500px; overflow: hidden;
    }
    
}
.detail-empty {
  min-height: 100px;
}
.detail-empty__tip {
  text-align: center;
  color: var(--text-color-6);
  margin-top: 100px;
  i {
    font-size: 84px;
    color: var(--text-color-9);
  }
  div {
    font-size: 16px;
    line-height: 22px;
    margin-top: 20px;
  }
}

.unfold-more{
    display: flex; justify-content: center;
    .zone{
        width: 300px; height: 50px; line-height: 50px; text-align: center; background: #e43a3a; color: #fff; border-radius: 25px;
    }
}
.zone{
    display: flex; justify-content: center; align-items: center; margin: 0 auto; cursor: pointer;
}
</style>